import {dicOption} from "@/option/config";
import {
  DATA_SOURCE_TYPE,
  INDEX_DROP_TYPE,
  INDEX_TYPE,
  INNER_CONFIG,
  SPREAD_SHEET_TYPE
} from "@/option/common/dict";
import {cloneDeep, merge} from "lodash-es";


const innerConfig = {
  [INNER_CONFIG.FIELD]: {
    name: '字段信息',
    code: INNER_CONFIG.FIELD
  },
  [INNER_CONFIG.BASIC_CONFIG]: {
    name: '基础配置',
    code: INNER_CONFIG.BASIC_CONFIG
  },
  [INNER_CONFIG.FORMAT]: {
    name: '格式化',
    code: INNER_CONFIG.FORMAT
  },
  [INNER_CONFIG.TIME_SHIFT]: {
    name: '时间偏移',
    code: INNER_CONFIG.TIME_SHIFT
  },
  [INNER_CONFIG.ADVANCED_CALC]: {
    name: '高级计算',
    code: INNER_CONFIG.ADVANCED_CALC
  },
  [INNER_CONFIG.INDEX_CONFIG]: {
    name: '指标配置',
    code: INNER_CONFIG.INDEX_CONFIG
  },
  [INNER_CONFIG.DRILLING]: {
    name: '钻取',
    code: INNER_CONFIG.DRILLING
  },
  [INNER_CONFIG.ADD_CONDITION]: {
    name: '附加条件',
    code: INNER_CONFIG.ADD_CONDITION
  },
  [INNER_CONFIG.COLUMN]: {
    name: '列配置',
    code: INNER_CONFIG.COLUMN
  }
}
// 维度的配置
const DIM_CONFIG = [innerConfig[INNER_CONFIG.FIELD], innerConfig[INNER_CONFIG.BASIC_CONFIG], innerConfig[INNER_CONFIG.FORMAT], innerConfig[INNER_CONFIG.DRILLING], innerConfig[INNER_CONFIG.ADD_CONDITION]]
// 指标的配置
const METRICS_CONFIG = [innerConfig[INNER_CONFIG.FIELD], innerConfig[INNER_CONFIG.BASIC_CONFIG], innerConfig[INNER_CONFIG.FORMAT], innerConfig[INNER_CONFIG.TIME_SHIFT], innerConfig[INNER_CONFIG.ADVANCED_CALC], innerConfig[INNER_CONFIG.ADD_CONDITION], innerConfig[INNER_CONFIG.INDEX_CONFIG]]
const COLUMN_CONFIG = [innerConfig[INNER_CONFIG.FIELD], innerConfig[INNER_CONFIG.BASIC_CONFIG], innerConfig[INNER_CONFIG.FORMAT], innerConfig[INNER_CONFIG.TIME_SHIFT], innerConfig[INNER_CONFIG.ADVANCED_CALC], innerConfig[INNER_CONFIG.ADD_CONDITION], innerConfig[INNER_CONFIG.INDEX_CONFIG], innerConfig[INNER_CONFIG.COLUMN]]
// 所有的可配置项目
//TODO 配置抽离


export const allConfig = {
  [INDEX_DROP_TYPE.ROW]: {
    name: '行',
    multiple: true,
    code: INDEX_DROP_TYPE.ROW,
    nameTip: '可拖指标维度',
    showEdit: true,
    // 维度指标配置项
    config: METRICS_CONFIG
  },
  [INDEX_DROP_TYPE.COLUMNS]: {
    name: '列',
    code: INDEX_DROP_TYPE.COLUMNS,
    nameTip: '可拖指标维度',
    showEdit: true,
    showFx: true,
    multiple: true,
    config: COLUMN_CONFIG
  },
  [INDEX_DROP_TYPE.DIMENSION]: {
    name: '维度（单选）',
    code: INDEX_DROP_TYPE.DIMENSION,
    multiple: false,
    nameTip: '',
    showEdit: true,
    config: DIM_CONFIG
  },
  [INDEX_DROP_TYPE.GROUP]: {
    name: '分组',
    code: INDEX_DROP_TYPE.GROUP,
    multiple: true, // 是否支持多选
    nameTip: '',
    showEdit: true,
    config: DIM_CONFIG
  },
  [INDEX_DROP_TYPE.METRICS]: {
    name: '指标',
    code: INDEX_DROP_TYPE.METRICS,
    multiple: true, // 是否支持多选
    nameTip: '',
    showEdit: true,
    showFx: true,
    config: METRICS_CONFIG
  },
  [INDEX_DROP_TYPE.REFERENCE]: {
    name: '参考线（可多选）',
    code: INDEX_DROP_TYPE.REFERENCE,
    nameTip: '',
    multiple: true, // 是否支持多选
    showEdit: true,
    showFx: true,
    config: METRICS_CONFIG
  },
  [INDEX_DROP_TYPE.ASSIST]: {
    name: '辅助指标',
    code: INDEX_DROP_TYPE.ASSIST,
    nameTip: '',
    multiple: true, // 是否支持多选
    showEdit: true,
    showFx: true,
    config: METRICS_CONFIG
  },
  [INDEX_DROP_TYPE.TOTAL]: {
    name: '总值指标',
    code: INDEX_DROP_TYPE.TOTAL,
    nameTip: '',
    multiple: true, // 是否支持多选
    showEdit: true,
    showFx: true,
    config: METRICS_CONFIG
  },
  [INDEX_DROP_TYPE.LABEL_IDENT]: { // 标签标识
    name: '标签标识',
    code: INDEX_DROP_TYPE.LABEL_IDENT,
    multiple: true, // 是否支持多选
    nameTip: '',
    showEdit: true,
    showFx: false,
    showBindModel: true,
    config: METRICS_CONFIG
  },
  [INDEX_DROP_TYPE.METRIC_R]: { // 次指标1
    name: '次指标',
    code: INDEX_DROP_TYPE.METRIC_R,
    multiple: true, // 是否支持多选
    nameTip: '',
    showEdit: true,
    showFx: true,
    config: METRICS_CONFIG
  },
  [INDEX_DROP_TYPE.METRIC_L]: { // 次指标2
    name: '次指标1',
    code: INDEX_DROP_TYPE.METRIC_L,
    multiple: true, // 是否支持多选
    nameTip: '',
    showEdit: true,
    showFx: true,
    config: METRICS_CONFIG
  }
}
// 所有分类对应的配置
const allTypeConfig = {
  type_common: [
    allConfig[INDEX_DROP_TYPE.DIMENSION],
    allConfig[INDEX_DROP_TYPE.GROUP],
    allConfig[INDEX_DROP_TYPE.METRICS],
    allConfig[INDEX_DROP_TYPE.ASSIST],
    allConfig[INDEX_DROP_TYPE.TOTAL]
  ],
  type_index: [allConfig[INDEX_DROP_TYPE.METRICS], allConfig[INDEX_DROP_TYPE.ASSIST]],
  type_circle: [
    allConfig[INDEX_DROP_TYPE.DIMENSION],
    allConfig[INDEX_DROP_TYPE.GROUP],
    allConfig[INDEX_DROP_TYPE.METRICS],
    allConfig[INDEX_DROP_TYPE.ASSIST],
    allConfig[INDEX_DROP_TYPE.TOTAL]],
  type_map: [
    allConfig[INDEX_DROP_TYPE.DIMENSION],
    allConfig[INDEX_DROP_TYPE.GROUP],
    allConfig[INDEX_DROP_TYPE.METRICS],
    {
      ...allConfig[INDEX_DROP_TYPE.METRIC_L],
      name: '经度（单选）',
      multiple: false
    }, {
      ...allConfig[INDEX_DROP_TYPE.METRIC_R], name: '纬度（单选）',
      multiple: false
    },
    allConfig[INDEX_DROP_TYPE.ASSIST],
    allConfig[INDEX_DROP_TYPE.TOTAL]
  ],
  type_table: [
    allConfig[INDEX_DROP_TYPE.ROW],
    allConfig[INDEX_DROP_TYPE.COLUMNS],
    allConfig[INDEX_DROP_TYPE.GROUP],
    allConfig[INDEX_DROP_TYPE.METRICS],
    allConfig[INDEX_DROP_TYPE.ASSIST]],
  type_panel: [
    allConfig[INDEX_DROP_TYPE.DIMENSION],
    allConfig[INDEX_DROP_TYPE.METRICS]],
  type_dist: [
    allConfig[INDEX_DROP_TYPE.DIMENSION],
    allConfig[INDEX_DROP_TYPE.METRICS],
    allConfig[INDEX_DROP_TYPE.GROUP]],
}
// 默认使用公用配置
const defaultConfig = [
  {
    name: '关联数据',
    nameTip: '',
    code: INDEX_DROP_TYPE.LINK,
    multiple: true,
    showEdit: false,
    showFx: false,
    showBindModel: false,
  },
  {
    name: '条件过滤',
    code: INDEX_DROP_TYPE.FILTER,
    multiple: true,
    nameTip: '',
    dropType: "conditions",
    showEdit: true,
    showFx: false,
    showBindModel: true
  }]

/**
 * 根据组件code和配置 动态生成组件的指标配置项
 *
 * @param config 在prop定义的组件配置
 */
export function generateConfig(config) {
  let res = []
  if (config) {
    if (config.type) {
      res = cloneDeep(allTypeConfig[config.type])
    }
    if (Array.isArray(config.add)) {
      config.add.forEach((el) => {
        if (typeof el === 'string') {
          res.push(allConfig[el])
        } else {
          // 改写默认的配置
          if (el.code) {
            let _origin = res.find(_el => _el.code === el.code)
            if (_origin) {
              // 直接修改原始值
              merge(_origin, el)
            } else {
              // 没有就从全部里面找
              _origin = allConfig[el.code]
              merge(_origin, el)
              res.push(_origin)
            }
          } else {
            res.push(el)
          }
        }
      })
    }
    if (config.del) {
      config.del.forEach((el) => {
        let index = res.findIndex(_el => _el.code === el.code)
        if (index !== -1) {
          res.splice(index, 1)
        }
      })
    }
  }
  // 没有任何配置 默认给通用的
  if (res.length === 0) {
    res = allTypeConfig.type_common
  }
  return [...res, ...defaultConfig]
}